import React from 'react';
// import member1 from '../../assets/static/images/lob-member1.jpg';
import member1 from './../../assets/static/images/lob-member-1.jpg';
import member2 from '../../assets/static/images/lob-member-2.jpg';
import member3 from '../../assets/static/images/lob-member-3.jpg';

export const data = {
  whoWeAre: `Historically Freemasonry had connections with Architecture, Building, Geometry and everything connected 
  with the built environment. This is where it got part of its title “Masonry”. Today, we at Pudsey Masonic Hall and 
  The Lodge of Benevolence No 5612, maintain the same connections with tradition but include all levels of society 
  and all sectors of commerce and industry. We’re not just rich older people, but a mixture of ages and backgrounds 
  coming together to share experience, strengths and abilities.

The old principles still apply to the expected conduct of Freemasons and the requirements of respect and thought 
for others in everything you do. How many times have you come across people who you think are friends but when it 
comes to the critical stage they think only of themselves. Many Freemasons say the when they joined they didn’t 
realise there were still people who thought of others first and themselves last and whose primary function is to 
help others either directly or indirectly. Who want to show support for local community organisations and who look 
outwards rather than inwards.

We at Pudsey Masonic Hall and The Lodge of Benevolence No 5612 do, of course, have a serious side to our organisation 
but also a fun side and enjoy the friendship offered by members of our lodge and across the whole worldwide network. 
Why not give up one night a week to join us at Pudsey Masonic Hall and The Lodge of Benevolence 5612 and meet up with 
friends that have a single vision of generosity, goodwill and charity and develop a good feeling about being involved.

Come and talk to us in The Lodge of Benevolence No 5612 and learn more about what we do at Pudsey Masonic Hall and 
what we stand for and break out of the everyday grind into something that is able to help you completely forget 
about problems at work, even if it’s only for one night.`
    .split('\n\n') // Use consistent double line breaks
    .map((paragraph, index) => (
      <p key={index}>
        {paragraph.trim()}
      </p>
    )),
    missionStatement: `At the core of our business lies a commitment to excellence and timeless care delivered at an 
  affordable price. We strive to provide and uphold the highest standard of care for our service users, 
  ensuring their needs are met with compassion and professionalism. We are committed to providing and maintaining 
  the highest degree of care for our service users. Our core driving force is client and employee retention, 
  achieved through continuous self-evaluation, service monitoring, ongoing training, staff assessments, effective 
  communication, and strict adherence to our guiding principles, policies, and procedures.

  We believe in proactive engagement, conducting regular spot checks to ensure that employee performance aligns 
  with our high care standards. Our expert management team meticulously evaluates all potential clients, 
  discussing their needs in detail to customize a care package that best suits them. This includes creating 
  personalized care management plans with regular visits and assignments tailored to meet each client's unique, 
  person-centered needs.

  To ensure continuity and trust, we assign a carefully selected, qualified, and trained healthcare worker from our 
  exceptional team as the primary caregiver for each client, minimizing rotations wherever possible. 
  Our management team will maintain regular contact with clients to ensure satisfaction with our services, 
  address their suggestions for improvement, and respond swiftly to any changes in their individual needs.

  We are dedicated to empowering our service users to make their own decisions, take control of their lives, 
  and maintain their independence. Excel Healthcare Services Limited is committed to respecting and honoring the 
  diverse needs and values of our clients across all aspects of their identity, including religion, culture, 
  race or ethnic origin, sexuality, political affiliation, marital status, parenthood, and disabilities.

  Furthermore, we uphold a zero-tolerance policy against any form of discrimination or abuse, ensuring that 
  all service users are treated equally and safeguarded from harm.`
    .split('\n\n') // Use consistent double line breaks
    .map((paragraph, index) => (
      <p key={index}>
        {paragraph.trim()}
      </p>
    ))
};

export const ourTeamImages = [
  {
    id: 'wm',
    title: 'Stephen Schofield',
    desc: '',
    img: member1,
    imgAlt: 'Stephen Schofield',
  },
  {
    id: 'sw',
    title: 'Keith Boydon',
    desc: '',
    img: member2,
    imgAlt: 'Alex Brown — Senior Warden',
  },
  {
    id: 'jw',
    title: 'Christoper Schofield',
    desc: '',
    img: member3,
    imgAlt: 'Chris Taylor — Junior Warden',
  },
];

